export default class LoadMore {
    constructor() {
        this.page = 1;
        this.loadMoreButton = document.querySelector('[data-load-more-toggle]');
        this.loadMoreContainer = document.querySelector('[data-load-more]');
        if (this.loadMoreButton && this.loadMoreContainer) {
            // Make sure load more is visible
            this.loadMoreLink = window.localize_script.admin_ajax + this.loadMoreContainer.getAttribute('data-load-more');
            this.loadMoreEventListeners();
        }
    }
    loadMoreEventListeners() {
        this.loadMoreButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.loadMorePosts();
        });
    }
    loadMorePosts() {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                page: this.page
            })
        };
        fetch(this.loadMoreLink, options)
            .then(response => response.json())
            .then((response) => {
            this.page++;
            this.apiResults = response.content;
            if (response.success === 0 || response.max_pages === response.page) {
                this.loadMoreButton.classList.add('hidden');
            }
            this.setDomElements();
        })
            .catch((error) => {
            console.error('Fetch error:', error);
        })
            .finally(() => {
            //
        });
    }
    setDomElements() {
        this.loadMoreContainer.insertAdjacentHTML('beforeend', this.apiResults);
    }
}
